import React from 'react';
import { Box, Card, CardContent, Typography, Stack, Link, IconButton, Button } from '@mui/material';
import {
  Close as CloseIcon,
  LocationOn as LocationIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Directions as DirectionsIcon
} from '@mui/icons-material';

function QuestSteps({ steps, currentStep, onStepClick, onCloseStep }) {
  const openNavigation = (name, address) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(name)} (${encodeURIComponent(address)})`;
    window.open(url, '_blank');
  };

  const sendEmail = (email) => {
    window.location.href = `mailto:${email}`;
  };

  const callPhone = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  function CurrentStep() {
    return (
      <Card variant="outlined" sx={{ mb: 4 }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5">
              {currentStep.id}. {currentStep.name}
            </Typography>
            <IconButton color="default" onClick={onCloseStep}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
            {currentStep.picture && (
              <Box sx={{ width: 200, flexShrink: 0, height: 'fit-content' }}>
                <img
                  src={currentStep.picture}
                  alt={currentStep.name}
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '8px'
                  }}
                />
              </Box>
            )}
            <Box sx={{ flex: 1 }}>
              {currentStep.address && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <LocationIcon />
                  <Typography sx={{ flex: 1 }}>{currentStep.address}</Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<DirectionsIcon />}
                    onClick={() => openNavigation(currentStep.name, currentStep.address)}
                  >
                    Navigate
                  </Button>
                </Box>
              )}

              {currentStep.email && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <EmailIcon />
                  <Typography sx={{ flex: 1 }}>{currentStep.email}</Typography>
                  <Button size="small" variant="outlined" onClick={() => sendEmail(currentStep.email)}>
                    Email
                  </Button>
                </Box>
              )}

              {currentStep.phone && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <PhoneIcon />
                  <Typography sx={{ flex: 1 }}>{currentStep.phone}</Typography>
                  <Button size="small" variant="outlined" onClick={() => callPhone(currentStep.phone)}>
                    Call
                  </Button>
                </Box>
              )}
            </Box>
          </Box>

          {currentStep.links?.length > 0 &&
            currentStep.links.map((link, i) => (
              <Link key={i} href={link.url} target="_blank" rel="noopener">
                {link.title || link.url}
              </Link>
            ))}

          {currentStep.description && (
            <Typography variant="body2" sx={{ mb: 2 }}>
              {currentStep.description}
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  }

  function Steps() {
    return (
      <Stack spacing={2}>
        {steps?.map((step, index) => (
          <Card
            key={index}
            variant="outlined"
            sx={{
              cursor: 'pointer',
              '&:hover': {
                boxShadow: 1,
                transform: 'translateY(-2px)',
                transition: 'all 0.2s ease-in-out'
              }
            }}
            onClick={() => onStepClick(step)}
          >
            <CardContent>
              <Box sx={{ display: 'flex', gap: 2 }}>
                {step.picture && (
                  <Box sx={{ width: 200, flexShrink: 0, height: 'fit-content' }}>
                    <img
                      src={step.picture}
                      alt={step.name}
                      style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '8px'
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6">
                    {index + 1}. {step.name}
                  </Typography>
                  {step.address && (
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      {step.address}
                    </Typography>
                  )}
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {step.description}
                  </Typography>
                  {step.latitude && step.longitude && (
                    <Box sx={{ mt: 2 }}>
                      <Link
                        href={`https://www.google.com/maps/search/?api=1&query=${step.latitude},${step.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View on Google Maps
                      </Link>
                    </Box>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Stack>
    );
  }

  if (currentStep) return CurrentStep();
  else return Steps();
}

export default QuestSteps;
